import { Link } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { CheckCircle2, ArrowLeft, Clock, Mail } from "lucide-react";

const LOGO = "/fabg-logo.png";

export default function ThankYou() {
  useEffect(() => {
    window.scrollTo(0, 0);
    // Meta Pixel: register the /thank-you view and fire the Lead conversion.
    // (SPA route change, so we re-fire PageView for URL-based custom conversions.)
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      window.fbq("track", "PageView");
      window.fbq("track", "Lead");
    }
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-border bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center">
          <img src={LOGO} alt="FABG Canada" className="h-8 w-auto" />
        </div>
      </header>

      <main className="hero-bg">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16 sm:py-24">
          <div className="rounded-2xl border border-border bg-white shadow-md p-8 sm:p-10 text-center">
            <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-accent">
              <CheckCircle2 className="h-9 w-9 text-primary" />
            </div>

            <h1
              data-testid="thank-you-headline"
              className="mt-6 text-3xl sm:text-4xl font-semibold tracking-tight text-foreground"
            >
              Application received.
            </h1>
            <p className="mt-3 text-base text-muted-foreground">
              Thank you for your interest in the Full Arch Buying Group. Your
              submission has been received successfully.
            </p>

            <div
              data-testid="thank-you-next-steps"
              className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4 text-left"
            >
              <div className="rounded-xl border border-border bg-secondary/60 p-4">
                <Clock className="h-5 w-5 text-primary" />
                <p className="mt-2 text-sm font-semibold text-foreground">
                  What happens next
                </p>
                <p className="mt-1 text-sm text-muted-foreground">
                  A member of our team will reach out within 1&ndash;2 business
                  days to discuss Founding Membership.
                </p>
              </div>
              <div className="rounded-xl border border-border bg-secondary/60 p-4">
                <Mail className="h-5 w-5 text-primary" />
                <p className="mt-2 text-sm font-semibold text-foreground">
                  Keep an eye on your inbox
                </p>
                <p className="mt-1 text-sm text-muted-foreground">
                  We&rsquo;ll follow up by email and phone using the details you
                  provided.
                </p>
              </div>
            </div>

            <div className="mt-8">
              <Button
                asChild
                variant="outline"
                data-testid="thank-you-back-button"
                className="h-11 rounded-xl"
              >
                <Link to="/">
                  <ArrowLeft className="mr-2 h-4 w-4" />
                  Back to FABG Canada
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
